export var abnMustBeValid = 'Please enter a valid ABN';
export var emailAddressMustBeValid = 'Please enter a valid email address';
export var timeZoneIsRequired = 'Please select a time zone';
export var noRecordsFound = 'Whoops! We could not find any records.';
export var requiredField = 'Required';
export var invalidField = 'Invalid';
export var minimumOneItem = 'Must have at least 1 item.';
export var sexIsRequired = 'Please enter a sex.';
export var familyNameIsRequired = 'Please enter a family name.';
export var givenNameIsRequired = 'Please enter a given name.';
export var invalidDate = 'Invalid date';
export var invalidYear = 'Year is invalid';
export var dateIsInTheFuture = 'Date is in the future';
export var yearIsInTheFuture = 'Year is in the future';
export var beforeStartDate = 'Before Start date';
export var afterExpiryDate = 'After Expiry date';
export var afterTodayDate = 'Date must be after today';
export var oneMedicationMustBeSelected = 'One medication must be chosen';
export var requestMustExpireBeforeMeds = 'Invalid expiry';
export var MedicationLocale = {
    PatientMedication_BeforeStartDate: beforeStartDate,
    PatientMedication_AfterExpiryDate: afterExpiryDate,
    PharmacyRequest_ExpiryDateRequired: requiredField,
    PharmacyRequest_ExpiryDateIsLessThanToday: afterTodayDate,
    PharmacyRequest_ExpiryIsGreaterThanMedicationMax: requestMustExpireBeforeMeds
};
